import React from 'react';

import { Grid } from '@mui/material';

import {
  SelectInput,
  SelectInputProps,
  required,
} from 'react-admin';
import CommentInput from '../../../comment/CommentInput';

const Select = ({ choices }: {
  choices: SelectInputProps['choices'];
}) => (
  <Grid
    size={{
      xs: 12,
      md: 7,
    }}
  >
    <Grid container>
      <Grid size={12}>
        <SelectInput
          choices={choices}
          fullWidth
          source="value"
          label="New value"
          validate={[required()]}
        />
      </Grid>
      <Grid size={12}>
        <CommentInput
          source="comment"
          helperText={false}
          placeholder="Please explain your decision."
          validate={[required()]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default Select;
